import Flickity from 'flickity';
import { debounce } from 'lodash';

let activeCarousel = null;
let activeIndex = 0;

const swappers = document.querySelector('.js-tabbed-carousel-swappers');
const carousels = Array.from(document.querySelectorAll('.js-tabbed-carousel'));

if (swappers && carousels.length) {
    const initCarousel = () => {
        const isMobile = window.matchMedia(`(max-width: 640px)`).matches;
        carousels[activeIndex].classList.remove('hidden');

        activeCarousel = new Flickity(carousels[activeIndex], {
            cellAlign: isMobile ? 'center' : 'left',
            prevNextButtons: false,
            pageDots: true,
            groupCells: true,
            wrapAround: true
        });

        activeCarousel.resize();
    };

    const reset = () => {
        activeCarousel.destroy();
        carousels.forEach((carousel) => carousel.classList.add('hidden'));
        initCarousel();
    };

    swappers.addEventListener('swap-carousel', (e) => {
        activeIndex = e.detail.active;
        reset();
    });

    window.addEventListener('resize', debounce(reset, 400));

    initCarousel(0);
}
